import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { SdkRanking } from '../models/sdkRanking';

@Component({
  template: `
    <div class="d-flex flex-column align-items-end align-items-lg-start gap">
      <div class="sdk-name" style="display: inline; text-align: left;">
        {{ data?.sdkName }}
      </div>
      <div class="name-tags">
        <span class="sdk-badge">{{ data?.appStore | platformMap }}</span>
        <span class="sdk-type">{{ data?.type }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .gap {
        gap: 4px;
      }

      .sdk-name {
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 6px;
        letter-spacing: -0.005em;
        word-wrap: break-word;
        overflow-wrap: break-word;
        display: inline;
        text-align: left;
        overflow: hidden;
      }

      .name-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
      }

      .sdk-type {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 14px;
        font-size: 11.5px;
        font-weight: 600;
        letter-spacing: 0.02em;
        background: white;
        border: 1px solid;

        color: #0d9488;
        border-color: #99f6e4;
        background: #ecfefe;
      }

      .sdk-badge {
        display: inline-block;
        padding: 4px 14px;
        background: #1e4fad;
        color: white;
        border-radius: 14px;
        font-size: 12px;
        font-weight: 600;
        box-shadow: 0 1px 2px rgba(30, 79, 173, 0.25);
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdkNameComponent extends DataWidgetComponent implements OnInit {
  @Input() data: SdkRanking;

  ngOnInit() {
    super.ngOnInit();
  }
}
